import React from 'react';
import CampaignHorizontalSubMenuComponent from './CampaignHorizontalSubMenuComponent';

// The Campaigns surface is the home page for signed-in users (App.js routes "/" -> Campaign).
// This is a thin wrapper around CampaignHorizontalSubMenuComponent which switches between
// the list view (NewCampaign) and the edit view (EditCampaign). All data-fetching and chrome
// live in the inner components so this stays trivially simple.
const Campaign = () => {
	return (
		<div className="min-h-screen w-full bg-white">
			<CampaignHorizontalSubMenuComponent index={0}/>
		</div>
	);
};

export default Campaign;
